import { Button } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Page from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'
import { CustomIframe } from '../../../components/shared/customIframe/customIframe'
import { NonAuthRoutes } from '../../../model'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../../redux'

export interface CommercialEditPageProps {}

export const CommercialEditPage: React.FC<any> = props => {
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  // const apiSuffixUrl = 'https://localhost:44379'
  const commercialID =
    props.location.state !== undefined ? (props.location.state.commercialId as number) : undefined

  const [t] = useTranslation(['globalerisLibrary', 'translation', 'commercial'])
  const history = useHistory()

  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()

  let route = `${apiSuffixUrl}/clientes/comercial/edit`
  if (commercialID) {
    route = route + `?commercialId=${commercialID}`
  }

  const [routeLocal, setRouteLocal] = useState(route)

  useEffect(() => {
    call()
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      setRouteLocal(route)
    }, 1000)
  }

  return (
    <Page>
      <PageHeader title={commercialID ? t('commercial:clientEdit') : t('commercial:clientAdd')}>
        <Button
          variant="text"
          color="primary"
          onClick={() => {
            history.push(NonAuthRoutes.Client)
          }}
        >
          {t('commercial:buttons.back')}
        </Button>
      </PageHeader>
      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
        button={true}
      />
    </Page>
  )
}
